import React from 'react';
import {Card, Avatar, Typography,CardContent} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomBtn from './CustomBtn'

const useStyles = makeStyles((theme) => ({
  CardStyle:{
    width: props =>(props.width),
    borderRadius:'50px',
    marginTop:'20px',
    marginLeft:'20px',
    marginRight:'20px',
  },
  ConetntStyle:{
    display:'flex',
    flexDirection:"row",
    justifyContent:'space-between',
    padding:'1.5rem',
    '@media (max-width:538px)':{
      flexDirection:"column",
      padding:'0.5rem',
    }
  },
  AvatarStyle:{
    width:theme.spacing(14),
    height:theme.spacing(14),
    backgroundColor:'#CCCCCC',
    '@media (max-width:538px)':{
      marginTop:'20px',
      width:theme.spacing(12),
      height:theme.spacing(12)
    }

  },
  container:{
    display:'flex',
    flexDirection:"column",
    justifyContent:'space-between',
    alignItems:'flex-end',
    flex:'1',
    '@media (max-width:538px)':{
      alignItems:'center',
      marginTop:'20px'
    }
  },
 containerTWO:{
   display:'flex',
   flexDirection:"row",
   alignItems:'center',
   flex:'1',
   '@media (max-width:400px)':{
     flexDirection:'column',
   }

 },
 ParagraphStyle:{
  marginLeft:'1rem',
  color:'#4F5052',
  fontFamily:['Nunito'].join(',')
 }

  }));

const AvatarCard =(props) =>{
  const classes = useStyles(props);
  return (
    <Card className={classes.CardStyle}>
    <CardContent className={classes.ConetntStyle}>
      <div className={classes.containerTWO}>
      <Avatar className={classes.AvatarStyle} src={props.picture}/>
      <Typography variant='h5' className={classes.ParagraphStyle} >
      <strong>{props.name}</strong>
      </Typography>
      </div>
      <div className={classes.container}>
      <CustomBtn colorwhite={false} width={'30%'} fntSize={'12px'} txt={'Slack'}/>
      <CustomBtn colorwhite={true} width={'30%'} fntSize={'12px'} txt={'Github'}/>
      </div>
      </CardContent>
    </Card>

  );
}

export default AvatarCard;

//Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
